import { Button } from "antd";
import React, { useEffect, useState } from "react";
import SisLoader from "../../../../widgets/loader";
import AuxiliaryMachinaryRow from "./MachinaryRow";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { machineMap } from "../../../../Data/data";
import AddOtherMachinaryModel from "../components/AddOtherMachineryModel";

function AuxiliaryMachinary({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [FilteredData, setFilteredData] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fields_name, set_fields_name] = useState("");
  const [responeData, setResponeData] = useState({});

  const LIST_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      post(ApiURL.list_machinary_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.response_data);
        }
      });
    } catch (error) {
      console.error("Error fetching machinary list:", error);
    } finally {
    }
  };

  useEffect(() => {
    LIST_API();
  }, []);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const ADD_API = (data) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      const machine_id = machineMap[data?.machinary_dropdown] || "";
      FORM_DATA.append("machine_id", machine_id);
      FORM_DATA.append("machinary_selected_dropdown", data?.machinary_dropdown);
      FORM_DATA.append("machinary_name", data?.machinary_name);
      FORM_DATA.append("machinary_make", data?.machinary_make);
      FORM_DATA.append("machinary_model", data?.machinary_model);
      FORM_DATA.append("description", data?.description);
      FORM_DATA.append("specification", data?.specification);
      FORM_DATA.append("fields_name", fields_name);
      FORM_DATA.append("status", isChecked ? 1 : 0);
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams));
      FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams));

      post(ApiURL.add_machinary_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Machinary Details Saved!", "Machinary Details Successfully Added!!");
          setIsModalOpen(false);
          LIST_API();
          set_loader(false);
          if (onSuccess) onSuccess();
        } else {
          set_loader(false);
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } finally {
    }
  };

  const UPDATE_API = (data) => {
    const machine_id = machineMap[data?.machinary_dropdown] || "";
    try {
      set_loader(true);
      const FORM_DATA = new FormData();
      FORM_DATA.append("machine_id", machine_id);
      FORM_DATA.append("machinary_selected_dropdown", data?.machinary_dropdown);
      FORM_DATA.append("machinary_name", data?.machinary_name);
      FORM_DATA.append("machinary_make", data?.machinary_make);
      FORM_DATA.append("machinary_model", data?.machinary_model);
      FORM_DATA.append("description", data?.description);
      FORM_DATA.append("specification", data?.specification);
      FORM_DATA.append("status", isChecked && fields_name ? "True" : "False");
      FORM_DATA.append("fields_name", fields_name);
      FORM_DATA.append("id", data?.id);
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("request_type", "add-edit");
      FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams));
      FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams));
      post(ApiURL.edit_view_machinary_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Congratulation!!", "Machinary Details Successfully Update!!");
          set_loader(false);
          setIsModalOpen(false);
          set_errors("");
          // VIEW_API(res?.machinary_data);
        } else {
          set_loader(false);
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } catch (error) {
      set_loader(false);
      ErrorToast("Error Occurred", "There was an error during registration.");
    }
  };

  const VIEW_API = (data) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("id", data?.id);
      FORM_DATA.append("machine_id", data?.machine_id);
      FORM_DATA.append("request_type", "view");
      post(ApiURL.edit_view_machinary_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setIsModalOpen(true);
          setResponeData(res?.machinary_data);
          if (res?.machinary_data?.fields_name) {
            setIsChecked(true);
          } else {
            setIsChecked(false);
          }
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          set_loader(false);
        }
      });
    } finally {
    }
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <h3 style={{ marginTop: "15px", marginBottom: "15px" }}>Machinary Information </h3>
        <Button
          type="primary"
          onClick={showModal}
          style={{ position: "absolute", right: "0px", top: "-10px" }}
        >
          Add Machinary
        </Button>

        <AddOtherMachinaryModel
          visible={isModalOpen}
          onOk={(data) => {
            if (responeData?.id) {
              UPDATE_API({ ...data, id: responeData.id });
            } else {
              ADD_API(data);
            }
          }}
          onCancel={() => {
            setIsModalOpen(false);
            setResponeData({});
          }}
          responeData={responeData}
          errors={errors}
        />
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {FilteredData?.length > 0 ? (
              <>
                {/* {FilteredData?.map((item) => ( */}
                <>
                  <AuxiliaryMachinaryRow data={FilteredData} onEdit={(row) => VIEW_API(row)} />
                </>
                {/* ))} */}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
}

export default AuxiliaryMachinary;
